import { isSet } from "../helpers/isset";

/**
 * Description: Initialise the inline search feilds
 * 
 * @class EnquiryLink
 * @typedef {EnquiryLink}
 */

class EnquiryLink {
    constructor (domNode, enquiryForm) {
        this.domNode = domNode;
        this.enquiryForm = enquiryForm;
        this.type = "simple";
        this.prefix = '';
        this.init();
    }

    init(){
        this.card = this.domNode.closest('.card');

        if(!isSet(this.card)){
            console.log(this.domNode + ' is not contained inside a card component');
            return;
        }

        this.cardTitle = this.card.querySelector('[data-title]');

        if(!isSet(this.cardTitle)){
            console.log('There is no assigned title element on ' + this.card);
            return;
        }

        this.title = this.escape(this.cardTitle.textContent);

        this.setMessagePrefix();

        this.domNode.addEventListener(
            'click',
            this.onEnquireButtonClick.bind(this)
        );
    }

    setMessagePrefix(){
        if(this.card.classList.contains('card--stock')){
            this.type = "stock";
            this.prefix = 'the stock item: '
        }else if(this.card.classList.contains('card--machinery--model')){
            this.type = "machinery";
            this.prefix = 'the machinery model: '
        }else if(this.card.classList.contains('card--simple')){
            this.type = "simple";
            this.prefix = '';
        }else{
            this.type = "simple";
            this.prefix = '';
        }
    }

    /**
     * Escapes a string
     * @param  {String}  string  The string that is to be escaped
     */
    escape(string) {
        return string
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }

    setQueryString(){
        localStorage.setItem(
            'message', 
            JSON.stringify({
                type: this.type,
                title: this.title
            })
        );
        this.domNode.href += '?enquire=true';
    }

    onEnquireButtonClick(e){
        e.stopPropagation();
        e.preventDefault();

        if(isSet(this.enquiryForm)){
            const messageField = this.enquiryForm.querySelector('.message textarea');

            if(isSet(messageField)){

    
                const messageValue = "Hello, I would like to make an enquiry regarding "+ this.prefix + ' "' + this.title + '"';
                messageField.value = messageValue;

                const yOffset = -100; 
                const y = this.enquiryForm.getBoundingClientRect().top + window.scrollY + yOffset;
                window.scrollTo(
                    {
                        top: y, 
                        behavior: 'smooth'
                    }
                );
            }
        } else{
            this.setQueryString();
            window.location.href = this.domNode.href;
        }
    }
}

exports.EnquiryLink = EnquiryLink;